<template>
	<div class="childDiv1 flex justify-center" id="page1" ref="mainEl" page="1">
		<video ref="videoEl" loop muted>
			<source type="video/mp4" />
			Your browser does not support HTML video.
		</video>
		<div class="absolute w-full h-full top-0 left-0 bg-black bg-opacity-[0.2]"></div>
		<img class="absolute center top-0 bottom-0" alt="" src="images/1x_images/section1/page1/logo.png" srcset="images/2x_images/section1/page1/logo.png 2x" />
		<img class="button absolute center top-[57%]" alt="" src="images/1x_images/section1/page1/btn-page1.png" srcset="images/2x_images/section1/page1/btn-page1.png 2x" @click="$emit('scrollTo', 2)" />
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";

export default {
	name: "page-1",
	data() {
		return {
			videoInterval: null,
			loaded: false,
		};
	},
	methods: {
		start() {
			console.log("start page 1");
		},
		stop() {
			console.log("stop page 1");
		},
		loadVideo() {
			fetch("/videos/Video-Home.mp4")
				.then((res) => {
					console.log("res1", res);
					if (this.loaded) return;
					const video = this.$refs.videoEl;
					video.src = "/videos/Video-Home.mp4";
					video.load();
				})
				.catch((e) => {
					console.log("error1", e);
				});
		},
		initVideo() {
			const video = this.$refs.videoEl;
			// prettier-ignore
			video.addEventListener("loadeddata", () => {
				console.log("video play");
				this.loaded = true;
				clearInterval(this.videoInterval);
				video.play();
				gsap.set(video, { autoAlpha: 1 });
				this.$emit('loaded');
			}, { once: true });
		},
	},
	mounted() {
		gsap.set(this.$refs.videoEl, { autoAlpha: 0 });
		this.videoInterval = setInterval(() => {
			this.loadVideo();
		}, 500);
		this.initVideo();
	},
};
</script>

<style scoped>
video {
	height: 100%;
	max-width: none;
}
</style>
